import { render, staticRenderFns } from "./PaymentTypeDetails_Details.vue?vue&type=template&id=0ea3520a&"
import script from "./PaymentTypeDetails_Details.vue?vue&type=script&lang=js&"
export * from "./PaymentTypeDetails_Details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports